import React from "react";
import { Link } from "react-router-dom";

export function SeecPageHeader({ title, description, active = "filings" }) {
  return (
    <header className="space-y-4 border-b border-gray-200 pb-4">
      <div>
        <h1 className="text-2xl font-bold tracking-tight text-gray-900 sm:text-3xl">{title}</h1>
        {description && <p className="mt-2 max-w-3xl text-sm text-gray-600">{description}</p>}
      </div>
      <nav aria-label="Campaign finance" className="flex flex-wrap gap-2">
        {[
          { id: "filings", to: "/seec", label: "Explore filings" },
          { id: "donors", to: "/seec/top-donors", label: "Top donors" },
        ].map(({ id, to, label }) => (
          <Link key={id} to={to} aria-current={active === id ? "page" : undefined}
            className={`rounded-md border px-4 py-2 text-sm font-semibold transition ${active === id
              ? "border-blue-700 bg-blue-700 text-white"
              : "border-gray-300 bg-white text-gray-700 hover:border-blue-300 hover:bg-blue-50"}`}>
            {label}
          </Link>
        ))}
      </nav>
    </header>
  );
}
